import { Microscope, Calculator, RefreshCw } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Microscope,
    title: "Assessment Iniziale",
    desc: "Analisi antropometrica (plicometro e circonferenze corporee), anamnesi sportiva e clinica, analisi delle abitudini reali. Costruiamo una baseline oggettiva.",
  },
  {
    n: "02",
    icon: Calculator,
    title: "Macro-Calcolati",
    desc: "Calorie e macronutrienti calibrati su composizione corporea, dispendio energetico e periodo di allenamento.",
  },
  {
    n: "03",
    icon: RefreshCw,
    title: "Adjustments Bisettimanali",
    desc: "Check-in ogni due settimane su peso, performance, sonno e adesione. Ogni numero diventa una decisione concreta.",
  },
];

export const Methodology = () => {
  return (
    <section
      id="metodo"
      data-testid="methodology-section"
      className="relative bg-white py-20 md:py-28"
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="text-xs uppercase tracking-[0.22em] text-[#1F6E45] font-bold mb-4">
              · Il metodo Sacco
            </div>
            <h2 className="font-display text-[#0E1A14] text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              Data-driven.
              <br />
              <span className="text-[#1F6E45]">Non a sensazione.</span>
            </h2>
            <p className="mt-6 text-[#4A5A52] text-base md:text-lg leading-relaxed max-w-md">
              Tre fasi, ripetute con disciplina. Ogni decisione poggia su un
              dato misurato, non su una moda alimentare. È così che otteniamo
              risultati che durano.
            </p>

            <div className="mt-8 bg-[#F7F9F7] border border-[#E1E7E3] rounded-2xl p-6">
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#1F6E45] font-bold mb-4">
                · Live composizione corporea
              </div>
              <div className="space-y-3">
                <Bar label="Massa magra" value={74} delta="+4.2 kg" />
                <Bar label="Massa grassa" value={32} delta="-7.1 kg" />
                <Bar label="Idratazione" value={88} delta="+3%" />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-4">
            {STEPS.map((s) => (
              <Step key={s.n} {...s} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const Step = ({ n, icon: Icon, title, desc }) => (
  <div className="bg-white border border-[#E1E7E3] rounded-2xl p-7 md:p-8 hover:border-[#1F6E45]/40 transition-all soft-shadow group">
    <div className="grid grid-cols-12 gap-5 items-start">
      <div className="col-span-2">
        <div className="font-display text-4xl md:text-5xl text-[#1F6E45] tracking-tight">{n}</div>
      </div>
      <div className="col-span-10">
        <div className="flex items-center gap-3 mb-2">
          <Icon size={20} strokeWidth={1.8} className="text-[#1F6E45]" />
          <h3 className="font-heading text-[#0E1A14] text-xl md:text-2xl font-bold tracking-tight">
            {title}
          </h3>
        </div>
        <p className="text-[#4A5A52] text-base leading-relaxed">{desc}</p>
      </div>
    </div>
  </div>
);

const Bar = ({ label, value, delta }) => (
  <div>
    <div className="flex items-center justify-between text-xs mb-1.5">
      <span className="text-[#0E1A14] font-semibold">{label}</span>
      <span className="text-[#1F6E45] font-bold">{delta}</span>
    </div>
    <div className="h-1.5 bg-[#E1E7E3] rounded-full overflow-hidden">
      <div className="h-full bg-[#1F6E45] rounded-full" style={{ width: `${value}%` }} />
    </div>
  </div>
);
